import { DateTime } from "luxon"

//SOAR components
import ProfilePhoto from "../../../components/ProfilePhoto"
import { LoaderSmall } from "../../../components/Loaders"

//SOAR Context
import { UserContext } from "../../../context/userContext"

//Styles
import myStyles from "../../../styles/housing/HousingAllocations.module.css"

//primeReact
import { Tooltip } from "primereact/tooltip"
import { LogDebug } from "../../../helpers/logger"
import { useContext } from "react"

export default function OccupantDetail({
  participant,
  bedOccupancy,
  participantsLoading,
  showHouse,
  showEdit,
  onEditClick,
  warningText,
  useAlternateBackground,
}) {
  const userCtx = useContext(UserContext)
  const otherOrgBooking =
    bedOccupancy?.organizationId !== userCtx.session.user.organization_id

  const startDate = DateTime.fromISO(bedOccupancy.start, {
    zone: "utc",
  })
    .toLocal()
    .toFormat("MM/dd/yyyy")
  const endDate = DateTime.fromISO(bedOccupancy.end, {
    zone: "utc",
  })
    .toLocal()
    .toFormat("MM/dd/yyyy")

  //Get the participant name, or if the occupancy is for another organization, just show Active Booking
  let participantName = participant?.name2 || "Unknown participant"
  if (otherOrgBooking) {
    participantName = "Active booking"
  }

  //set participant demographics
  const hasDemoData =
    !!participant &&
    (!!participant?.demo_race ||
      !!participant?.demo_gender ||
      !!participant?.demo_ethnicity ||
      !!participant?.demo_age)

  return (
    <div
      className={`${myStyles.occupantGridContainer} ${
        useAlternateBackground
          ? myStyles.occupantGridContainerAlternateBackground
          : ""
      }`}
    >
      <div className={myStyles.occupantGridItemPhoto}>
        <div>
          <ProfilePhoto
            participant_profile_image={
              participant?.participant_profile_image || null
            }
          />
        </div>
      </div>
      {!!showEdit && !participantsLoading && !otherOrgBooking ? (
        <div className={myStyles.occupantGridItemEdit}>
          <Tooltip target=".house-activity-t-tip" />
          <button
            className={`btn ${myStyles.editStayButton} house-activity-t-tip`}
            data-pr-tooltip={"Edit bed allocation"}
            onClick={() => {
              if (!!onEditClick) {
                onEditClick(bedOccupancy)
              } else {
                LogDebug("OccupantDetail: No edit click specified")
              }
            }}
          >
            <span className={`material-icons`}>{"edit"}</span>
          </button>
        </div>
      ) : null}

      <div className="">
        {participantsLoading ? (
          <div className={myStyles.occupantGridItemName}>
            <LoaderSmall />
          </div>
        ) : (
          <>
            <div className={myStyles.occupantGridItemName}>
              {participantName}
            </div>

            {!!warningText ? (
              <div className={myStyles.occupantGridItemWarning}>
                {warningText}
              </div>
            ) : null}
            {!otherOrgBooking ? (
              <div className={myStyles.occupantGridItemInfo}>
                {hasDemoData ? (
                  <>
                    <Tooltip target=".demo-t-tip" />
                    <div style={{ display: "flex", alignContent: "baseline" }}>
                      <div
                        style={{ display: "flex", alignContent: "baseline" }}
                        className="demo-t-tip"
                        data-pr-tooltip={"Age"}
                      >
                        <span className="material-icons top-icon-span">
                          {"calendar_month"}
                        </span>
                        {!!participant?.demo_age
                          ? `${participant?.demo_age} years`
                          : "N/A"}
                      </div>
                      <div
                        style={{
                          display: "flex",
                          alignContent: "baseline",
                          marginLeft: !!participant?.demo_age ? "10px" : "0px",
                        }}
                        className="demo-t-tip"
                        data-pr-tooltip={"Gender"}
                      >
                        <span className="material-icons top-icon-span">
                          {"person"}
                        </span>
                        {!!participant?.demo_gender
                          ? participant?.demo_gender
                          : "N/A"}
                      </div>
                    </div>

                    {!!participant?.demo_ethnicity ? (
                      <div>
                        <b>Ethnicity: </b>
                        {participant?.demo_ethnicity}
                      </div>
                    ) : null}
                    {!!participant?.demo_race ? (
                      <div>
                        <b>Race: </b>
                        {participant?.demo_race}
                      </div>
                    ) : null}
                  </>
                ) : (
                  "No demographics available"
                )}
              </div>
            ) : null}
          </>
        )}

        <div className={myStyles.occupantGridItemHouse}>
          {showHouse ? (
            <>
              <b>House: </b> {bedOccupancy.bed?.room?.house?.name}
            </>
          ) : null}
        </div>
        <div className={myStyles.occupantGridItemBed}>
          <b>Bed: </b> {bedOccupancy.bed.name}
        </div>
        <div className={myStyles.occupantGridItemDates}>
          <b>Dates: </b> {startDate} to {endDate}
        </div>
      </div>
    </div>
  )
}
